import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs: FAQItem[] = [{
    question: 'Can I use this alongside minoxidil?',
    answer: 'Yes. Photobiomodulation has been studied as an adjunct to topical therapies. Several trials show additive benefit. CrownControl™ does not interfere with minoxidil application.'
  }, {
    question: 'What if my hair loss is too advanced?',
    answer: "CrownControl™ is most effective for men with early to moderate androgenetic alopecia who still have miniaturized follicles in affected areas. If the scalp is fully smooth and has been inactive for many years, reactivation becomes significantly less likely. If you're uncertain about your stage, consult a dermatologist before purchasing. We'd rather lose the sale than overpromise."
  }, {
    question: 'Can I use both finasteride and CrownControl™?',
    answer: "Many men do. They operate through independent mechanisms. That's a conversation between you and your doctor; we won't advise either way. What we will say: CrownControl™ does not interact with DHT-blocking drugs."
  }, {
    question: 'Is the FDA clearance real?',
    answer: 'Yes. Devices in the FDA 510(k) cleared class for at-home hair loss have passed substantive regulatory review – not self-certification or a label claim. Clinical evidence is submitted for a specific indication, age range, and skin phototype. Clearance documentation is available on request.'
  }, {
    question: 'Do I have to use it forever?',
    answer: "Hair loss is an ongoing biological process. If you stop any intervention, the underlying factors continue. Most men who see results maintain the protocol because 10 minutes to protect a result they spent months earning is a trade they're happy to make. We won't call it a cure. We will call it a commitment worth making."
  }, {
    question: 'How fast does it ship?',
    answer: 'Orders ship within 2 business days. Free shipping included. Tracking provided at dispatch.'
  }];
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-bg-primary py-20 px-4" data-id="element-66">
      <div className="max-w-4xl mx-auto" data-id="element-67">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-68">
          {/* Section Label */}
          <p className="text-accent-red font-semibold text-sm uppercase tracking-wider mb-4" data-id="element-69">
            Quick Answers
          </p>

          {/* Headline */}
          <h2 className="text-3xl md:text-4xl font-bold text-text-primary mb-12" data-id="element-70">
            Still Have a Question? Here.
          </h2>

          {/* FAQ Accordion */}
          <div className="space-y-4" data-id="element-71">
            {faqs.map((faq, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: index * 0.05
          }} className="bg-bg-secondary border border-bg-tertiary rounded-lg overflow-hidden" data-id="element-72">
                <button onClick={() => toggleFAQ(index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-bg-tertiary transition-colors duration-200" aria-expanded={openIndex === index} aria-controls={`faq-answer-${index}`} data-id="element-73">
                  <span className="text-lg font-semibold text-text-primary pr-4" data-id="element-74">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} data-id="element-75">
                    <ChevronDownIcon className="w-6 h-6 text-accent-red flex-shrink-0" aria-hidden="true" data-id="element-76" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-77">
                  {openIndex === index && <motion.div id={`faq-answer-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-78">
                      <div className="px-6 pb-6 pt-2" data-id="element-79">
                        <p className="text-text-secondary leading-relaxed" data-id="element-80">
                          {faq.answer}
                        </p>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}